export default __webpack_public_path__ + "static/media/Grid3.2.c0912b6c.jpg";